export const SUPPORT_EMAIL = 'andy@shuttleops.com';
export const SUPPORT_PORTAL_URL = 'https://app.shuttleops.com/help';
